import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { reject } from 'lodash';
import getGeneric from '../../../actions/getGeneric';
import { parseFilters } from '../../Filters/utils/fetchData';
import { transformApiResponse, transformApiResponseToColumns } from '../../../components/ExpandableGrid/utils';

const useExpandableGridHelper = ({ widgetId, appliedFilterValues, onAggregationResponseFn = () => {} }) => {
  const dispatch = useDispatch();
  const [loadingData, setLoadingData] = useState(false);
  const [error, setError] = useState(null);

  const [tableColumns, setTableColumns] = useState([]);

  const requestAggregatedData = useCallback(
    widget_config => {
      const { filters, benchmark } = parseFilters(appliedFilterValues);
      if (!widgetId) reject();
      return new Promise((resolve, reject) => {
        dispatch(
          getGeneric({
            requestBody: {
              data_tag: 'DATATAG_DELIGHTIQ_GET_AGGREGATED_DATA',
              request_data: {
                widget_id: widgetId,
                filters,
                benchmark,
                widget_config
              }
            },

            onSuccess: response => {
              const raw = response.api_response.APITAG_DELIGHTIQ_AGGREGATE_DATA || {};
              const status = raw?.status;
              if(status != 'SUCCESS') reject("No Data"); 
              const tableData = transformApiResponse(raw);
              const columns = transformApiResponseToColumns(raw);
              const totalRecords = raw?.data?.['total_records'];

              setTableColumns(columns);

              resolve({ tableData, columns, totalRecords });

              onAggregationResponseFn({
                rawData: raw,
                tableData,
                totalRecords,
                tableColumns: columns,
                widget_config,
                widgetId
              });
            },
            onError: error => {
              reject(error);
            }
          })
        );
      });
    },
    [dispatch, widgetId, appliedFilterValues]
  );

  const fetchData = useCallback(
    async (options = {}) => {
      const { widget_config = {}, page, pageSize, sortField, sortDirection } = options;

      try {
        setLoadingData(true);
        const result = await requestAggregatedData(widget_config);
        return result;
      } catch (err) {
        setError(err?.message || 'Something went wrong');
        return null;
      } finally {
        setLoadingData(false);
      }
    },
    [requestAggregatedData]
  );

  return {
    fetchData,
    loadingData,
    tableColumns,
    setTableColumns,
    error
  };
};

export default useExpandableGridHelper;
